import { takeLatest, put } from 'redux-saga/effects';
import {
  getCountryListSuccess, getCountryListFail,
  getEmployeeListSuccess, getEmployeeListFail,
  getLeaveTypeListSuccess, getLeaveTypeListFail,
  getDepartmentListSuccess, getDepartmentListFail,
  getLeaveStateListSuccess,
  getHrCategoryListSuccess, getHrCategoryListFail,
  getItCategoryListSuccess, getItCategoryListFail,
  getPsCategoryListSuccess, getPsCategoryListFail,
  getTicketStatusListSuccess, getTicketStatusListFail,
  getPsTypeListSuccess, getPsTypeListFail,
  getCoreValuesListSuccess, getCoreValuesListFail,
  getClientListSuccess, getClientListFail,
  getEmploymentStatusListSuccess, getEmploymentStatusListFail,
  getForexListSuccess, getForexListFail,
  getAssetTypeListSuccess, getAssetTypeListFail,
  getAssetStatusListSuccess, getAssetStatusListFail,
  getAnnouncementCategoryListSuccess, getAnnouncementCategoryListFail,
  getTimecardUpdateRequestStatusListSuccess, getTimecardUpdateRequestStatusListFail,
} from './optionlistState';
import createCrudService from '../../services/crudservice';
import { doCrudCall } from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/console/options');

function* getCountryList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('country-list',data.payload), 
		getCountryListSuccess, 
		getCountryListFail);
}

function* getEmployeeList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('employee-list',data.payload), 
		getEmployeeListSuccess, 
		getEmployeeListFail);
}

function* getLeaveTypeList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('leave-type-list',data.payload), 
		getLeaveTypeListSuccess, 
		getLeaveTypeListFail);
}

function* getDepartmentList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('department-list',data.payload), 
		getDepartmentListSuccess, 
		getDepartmentListFail);
}

function* getLeaveStateList() {
  	yield put(getLeaveStateListSuccess());
}

function* getHrCategoryList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('hr-category-list',data.payload), 
		getHrCategoryListSuccess, 
		getHrCategoryListFail);
}

function* getItCategoryList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('it-category-list',data.payload), 
		getItCategoryListSuccess, 
		getItCategoryListFail);
}

function* getPsCategoryList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('ps-category-list',data.payload), 
		getPsCategoryListSuccess, 
		getPsCategoryListFail);
}
 
function* getTicketStatusList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('ticket-status-list',data.payload), 
		getTicketStatusListSuccess, 
		getTicketStatusListFail);
}

function* getPsTypeList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('ps-type-list',data.payload), 
		getPsTypeListSuccess, 
		getPsTypeListFail);
}

function* getCoreValuesList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('core-values-program',data.payload), 
		getCoreValuesListSuccess, 
		getCoreValuesListFail);
}

function* getClientList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('client-list',data.payload), 
		getClientListSuccess,
		getClientListFail);
}

function* getEmploymentStatusList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('employment-status-list',data.payload), 
		getEmploymentStatusListSuccess, 
		getEmploymentStatusListFail);
}

function* getForexList(data){
	yield doCrudCall(
		() => crudService.doGetRequest('forex-list',data.payload), 
		getForexListSuccess,
		getForexListFail);
}

function* getAssetTypeList(data) {
    yield doCrudCall(
        () => crudService.doGetRequest("asset-type-list", data.payload),
        getAssetTypeListSuccess,
        getAssetTypeListFail
    );
}

function* getAssetStatusList(data) {
    yield doCrudCall(
        () => crudService.doGetRequest("asset-status-list", data.payload),
        getAssetStatusListSuccess,
        getAssetStatusListFail
    );
}

function* getAnnouncementCategoryList(data) {
    yield doCrudCall(
        () => crudService.doGetRequest("announcement-category-list", data.payload),
		getAnnouncementCategoryListSuccess, 
		getAnnouncementCategoryListFail,
    
	);
}
function* getTimecardUpdateRequestStatusList(data) {
    yield doCrudCall(
        () => crudService.doGetRequest("timecard-update-request-status-list", data.payload),
		getTimecardUpdateRequestStatusListSuccess, 
		getTimecardUpdateRequestStatusListFail,
    );
}

function* optionlistSaga() {
	yield takeLatest('optionlist/getCountryList', getCountryList);
	yield takeLatest('optionlist/getEmployeeList', getEmployeeList);
	yield takeLatest('optionlist/getLeaveTypeList', getLeaveTypeList);
	yield takeLatest('optionlist/getDepartmentList', getDepartmentList);
	yield takeLatest('optionlist/getLeaveStateList', getLeaveStateList);
	yield takeLatest('optionlist/getHrCategoryList', getHrCategoryList);
	yield takeLatest('optionlist/getItCategoryList', getItCategoryList);
	yield takeLatest('optionlist/getPsCategoryList', getPsCategoryList);
	yield takeLatest('optionlist/getTicketStatusList', getTicketStatusList);
	yield takeLatest('optionlist/getPsTypeList', getPsTypeList);
	yield takeLatest('optionlist/getCoreValuesList', getCoreValuesList);
	yield takeLatest('optionlist/getClientList', getClientList);
	yield takeLatest('optionlist/getEmploymentStatusList', getEmploymentStatusList);
	yield takeLatest('optionlist/getForexList', getForexList);
	yield takeLatest("optionlist/getAssetTypeList", getAssetTypeList);
	yield takeLatest("optionlist/getAssetStatusList", getAssetStatusList);
	yield takeLatest("optionlist/getAnnouncementCategoryList", getAnnouncementCategoryList);
	yield takeLatest("optionlist/getTimecardUpdateRequestStatusList", getTimecardUpdateRequestStatusList);
}

export default optionlistSaga;
